var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.076 9.1884C12.0838 9.19618 14.49 11.6029 14.49 11.6029C15.1905 12.6724 13.6399 14.0346 12.8049 14.4707C11.8693 14.9596 10.5138 14.4279 9.61709 14.029C8.01428 13.3168 6.6237 12.2468 5.38979 11.0129C4.00865 9.6423 2.76918 8.17783 1.97139 6.38279C1.5725 5.48556 1.04082 4.13053 1.52916 3.19496C1.96528 2.35939 3.32808 0.809361 4.39755 1.50993L6.81148 3.92386C7.71816 4.83054 5.86035 5.93723 5.8598 6.71613C5.85924 7.23837 6.1548 7.70949 6.42203 8.13671C6.73926 8.64284 7.1526 9.08507 7.63761 9.43285C8.09706 9.76286 8.69929 10.1412 9.2843 10.1406C10.0626 10.1401 11.1693 8.28172 12.076 9.1884Z",
    fill: "#6B757A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone4);
export default __webpack_public_path__ + "static/media/phone-4.3c699715.svg";
export { ForwardRef as ReactComponent };